import type {Employee} from "../domain/entities/employee.entity";
import type {EmployeeToIssueAssignment} from "../domain/entities/employee-to-issue-assignment.entity";

/**
 * Derives an issue's `employees` list from its employee-to-issue assignments.
 *
 * The issue dialog edits and saves only the assignments; views such as `/by-assignee`
 * place an issue by the derived `employees` list. DtoToIssueTransformer derives the same
 * list when an issue is loaded from the server (dto-to-issue.transformer.ts).
 */
export class IssueEmployeesHelper {

    /**
     * Resolves the employee of every assignment, in assignment order. Assignments without
     * an employee (an empty row in the dialog) and lookups that fail are left out instead
     * of failing the whole call: a single employee that can no longer be found must not
     * stop the issue from being saved.
     */
    public static async fromAssignments(assignments: EmployeeToIssueAssignment[]): Promise<Employee[]> {
        const results = await Promise.allSettled(
            assignments.map(assignment => Promise.resolve(assignment.employee))
        );

        return results
            .map(result => result.status === `fulfilled` ? result.value : null)
            .filter((employee): employee is Employee => employee != null);
    }
}
